<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-group"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="info" size="sm" @click="storeModal()">Nueva Serie</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable 
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
      >
        <template #type="{item}"><td>{{item.type == "I" || item.type == "income" ? "Ingreso" : (item.type == "E" || item.type == "expense" ? "Egreso" : (item.type == "P" || item.type == "payment" ? "Pago" : "Nómina"))}}</td></template>
        <template #serial="{item}"><td class="text-center">{{item.serial}}</td></template>
        <template #current="{item}"><td class="text-center">{{item.current}}</td></template>
        <template #actions="{item}">
          <td class="table_actions b2">
            <CButton color="warning" size="sm" @click="updateModal(item)"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <SerialModal ref="serialModal" @store="storeProcess" @update="updateProcess"></SerialModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import SerialModal from './SerialModal.vue'
import DeleteModal from '../../global/DeleteModal.vue'
import ws from '../../../services/serials';
import store from '../../../store'

export default {
  name: 'SerialsTable',
  components: { SerialModal, DeleteModal }, 
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'type', label: 'Tipo de Documento'},
          {key: 'serial', label: 'Serie'},
          {key: 'current', label: 'Folio Actual'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: []
    }
  },
  methods: {
    storeModal () {
      this.$refs.serialModal.storeModal();
    },
    updateModal (item) {
      this.$refs.serialModal.updateModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Serie", item.id, item.serial+""+item.current);
    },
    async storeProcess(data) {
      let response = await ws.store(data);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete(id);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
  }
}
</script>
